import m from 'mithril'


class Button {
    view(vnode) {
        return m('button[type="button"].btn', vnode.attrs, vnode.children)
    }
}

export default Button